export default __webpack_public_path__ + "static/media/iconConfirm.78a57d8b.svg";